<template>
  <div class="container-content">
    <div class="home-container"></div>
    <div class="body-container">
      <div class="body-content">
        <span class="location">您现在所在的位置：标准>{{curr==='2'?'国家标准':'行业标准'}}</span>
        <span class="search" style="position:relative">
          <!-- {{curr==='2'?'国家标准':'行业标准'}}查询 -->
          <input
            :placeholder="curr==='2'?'国家标准搜索':'行业标准搜索'"
            v-model="searchValue"
          />
          <img
            @click="toCommon({name:'标准'})"
            style="width:20px;height:20px;position:absolute;top:20px;right:250px"
            src="../../assets/images/search.svg"
          />
        </span>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="headline">
            <div class="img">
              <img src="../../assets/images/icon/icon-bz.png" alt />
            </div>
            <div class="word">
              <span class="character">标准</span>
              <span class="english">standard</span>
            </div>
          </div>
          <div class="frame">
            <div v-if="curr !=='2'" class="state" @click="switchTab('2')">国家标准</div>
            <div v-if="curr ==='2'" class="state active" @click="switchTab('2')">国家标准</div>
            <div v-if="curr !=='3'" class="industry" @click="switchTab('3')">行业标准</div>
            <div v-if="curr ==='3'" class="industry active" @click="switchTab('3')">行业标准</div>
          </div>
        </div>
        <!--
        -->
        <div class="content-right">
          <div class="details-list">
            <div class="list-head">
              <div class="state-head">{{curr==='2'?'国家标准':'行业标准'}}</div>
              <div class="english-head">{{curr==='2'?'National standard':'Industry standard'}}</div>
            </div>
            <ul>
              <li @click="particulArs(item.id)" v-for="item in normalListData" :key="item.id">
                <a>{{item.name}}</a>
                <span class="right-time">{{item.pubTime}}</span>
              </li>
            </ul>
          </div>
          <loading />
          <pagination :page="page" @on-change="changePage"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination';
import loading from '@/components/loading';
export default {
  components: {
    Pagination,
    loading
  },
  data () {
    return {
      curr: '2',
      searchValue: '',
      page: {
        currPage: 1,
        pageSize: 10
      },
      listParams: {
        category: '2'
      },
      normalListData: []
    };
  },
  created () {},
  computed: {},
  mounted () {
    this.getData();
  },
  methods: {
    particulArs (id) {
      window.localStorage.setItem('id', id);
      this.$router.push({ path: '/standardDetail' });
    },
    toCommon (obj) {
      this.$store.commit('saveSearchInputValue', this.searchValue);
      this.$store.commit('saveNormalList', []);
      localStorage.setItem('filterValue', obj.name);
      this.$store.commit('saveFilterValue');
      this.$store.commit('saveIsHot', false);
      this.$store.commit('saveIsTopNav', false);
      this.$router.push({ path: '/commonList' });
      this.$store.commit(
        'saveMultipleValue',
        this.curr === '2' ? '国家标准' : '行业标准'
      );
    },
    switchTab (category) {
      this.curr = category;
      this.listParams.category = category;
      this.getListData();
    },
    changePage (page) {
      this.page.currPage = page;
      this.getListData();
      // this.getAccountList();
    },
    getData () {
      let url = '/aqsiq/sta/sta/list';
      this.post(url, {
        query: this.listParams ? this.listParams : {},
        page: this.page
      }).then(res => {
        this.normalListData = [];
        this.normalListData = res.data.list;
        this.page = res.data.page;
      });
    },
    getListData () {
      let url = '/aqsiq/sta/sta/list';
      this.verify(
        'post',
        url,
        { query: this.listParams ? this.listParams : {}, page: this.page },
        res => {
          this.normalListData = [];
          this.normalListData = res.data.list;
          this.page = res.data.page;
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.container-content {
  width: 100%;
  // max-width: 1920px;
  .home-container {
    position: relative;
    height: 343.8px;
    width: 100%;
    background-size: 100%;
    background-position: center;
    background-image: url("../../assets/images/standard.png");
    background-repeat: no-repeat;
  }
  .body-container {
    width: @body-width;
    margin: 0 auto;
    .body-content {
      width: @body-width;
      line-height: 60px;
      background: #f5f5f5;
      margin: 30px auto 20px auto;
      padding-left: 24px;
      .search {
        input::-webkit-input-placeholder {
          padding-left: 40px;
          opacity: 0.5;
        }
        input{
          width:250px;height:38px;padding-left:30px;border:1px solid @color-base
        }
        padding-right: 26px;
        float: right;
        color: RGBA(128, 128, 128, 1);
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
      }
      .location {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .content {
      width: @body-width;
      margin: 0 auto;
      padding-bottom: 120px;
      .content-left {
        display: inline-block;
        float: left;
        width: 244px;
        height: 464px;
        .headline {
          padding: 10px 30px;
          width: 244px;
          height: 64px;
          background-color: @color-base;
          .img {
            vertical-align: middle;
            display: inline-block;
            margin-bottom: 30px;
            margin-right: 5px;
          }
          .word {
            display: inline-block;
            .character {
              display: block;
              font-size: 18px;
              font-weight: 500;
              color:#f5f5f5;
            }
            .english {
              font-size: 12px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.4);
            }
          }
        }
        .frame {
          width: 220px;
          height: 400px;
          background: #f5f5f5;
          padding: 20px 24px;
          .state {
            padding-left: 14px;
            width: 220px;
            line-height: 36px;
            font-size: 16px;
            font-weight: 500;
            // color: rgba(0, 0, 0, 0.65);
          }
          .active {
            color: #f5f5f5;
            background-image: url("../../assets/images/icon/bj.svg");
          }
          .industry {
            cursor: pointer;
            padding-left: 14px;
            width: 220px;
            line-height: 36px;
            font-size: 16px;
            font-weight: 400;
            // color: rgba(0, 0, 0, 0.65);
          }
        }
      }
      .content-right {
        padding:24px 0 0 30px;
        vertical-align:top;
        display: inline-block;
        width: 954px;
        min-height: 464px;
        border: 1px solid rgba(0, 0, 0, .1);
        margin-left: -1px;
        .details-list {
          li:before {
            content: "\2022"; //圆点
            color: rgba(0, 0, 0, 0.25); //颜色
            font-size: 16px;
            padding-right: 8px; //大小
          }
          ul li {
            // list-style: disc;
            color: rgba(0, 0, 0, 0.25);
            width: 896px;
            line-height: 54px;
            span {
              float: right;
              color: RGBA(155, 155, 155, 1);
            }
            a {
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
            }
          }
          li:hover {
            cursor: pointer;
            color: rgba(0, 141, 255, 1);
            box-shadow: 0 4px 6px 0 rgba(0, 141, 255, 0.1);
            border: none;
          }
          li:hover a {
            color: rgba(0, 141, 255, 1);
          }
        }
        .list-head {
          height: 40px;
          border-bottom: 1px solid rgba(0,0,0,0.1);
          .state-head {
            display: inline-block;
            line-height: 18px;
            width: 90px;
            font-size: 18px;
            font-weight: 500;
            color: @color-base;
            border-right: 1px solid rgba(216, 216, 216, 1);
          }
          .english-head {
            margin-left: 12px;
            display: inline-block;
            font-size: 16px;
            font-weight: 400;
            color: rgba(@color-base, 0.65);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/standArd/standard.vue